import React, { Fragment, useState, useEffect } from "react";
import Chart from "react-apexcharts";

const BarChart = (props) => {
  //console.log(props)  
 return  <>
    <Chart options={props.options} series={props.series} type="bar" height={props.height} />
    </>
}

export default BarChart;